(() => {
  if (customElements.get('iy-ready10-promo')) return;
  customElements.define('iy-ready10-promo', class extends HTMLElement {
    connectedCallback() {
      if (this.timer) return;
      const deadline = Date.parse(this.dataset.deadline);
      const output = this.querySelector('[data-promo-countdown]');
      if (!Number.isFinite(deadline) || !output) return;
      const update = () => {
        let seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
        const days = Math.floor(seconds / 86400); seconds %= 86400;
        const hours = Math.floor(seconds / 3600); seconds %= 3600;
        const minutes = Math.floor(seconds / 60); seconds %= 60;
        const pad = value => String(value).padStart(2, '0');
        output.textContent = ` · ${days}d ${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`;
        if (Date.now() >= deadline) { clearInterval(this.timer); this.timer = null; }
      };
      this.timer = setInterval(update, 1000);
      update();
    }
    disconnectedCallback() { clearInterval(this.timer); this.timer = null; }
  });
})();
